import React from "react";
import "./SortBar.css"

function SortBar({ onSortChange }) {
    return (
        <div className="sort-bar">
            <label>Sort By:</label>
            <select onChange={(e) => onSortChange(e.target.value)}>
                <option value="health">Health</option>
                <option value="damage">Damage</option>
                <option value="armor">Armor</option>
                <option value="bot_class">Class</option>
            </select>
        </div>
    );
}

export default SortBar;
